import styled, { css } from "styled-components";

/* -------------------------
   1. Variant Color System
------------------------- */
const COLOR = {
  neutral: {
    bg: "#ffffff",
    bg2: "#f8fafc",
    bd: "#dce1e7",
    fg: "#1e293b",
    hoverBg: "#f1f5f9",
    hoverBd: "#cbd5e1",
  },
  success: {
    bg: "#e7faf2",
    bg2: "#d1f5e4",
    bd: "#8ae4c2",
    fg: "#065f46",
    hoverBg: "#c7f0dd",
    hoverBd: "#5cd8b1",
  },
  warning: {
    bg: "#fff4e6",
    bg2: "#ffe8cc",
    bd: "#f7c98f",
    fg: "#92400e",
    hoverBg: "#ffdcb3",
    hoverBd: "#f1b86d",
  },
  info: {
    bg: "#e8f2ff",
    bg2: "#d7e7ff",
    bd: "#a8caff",
    fg: "#084c9e",
    hoverBg: "#c9dcff",
    hoverBd: "#7fb0ff",
  },
  danger: {
    bg: "#ffe9e9",
    bg2: "#ffd3d3",
    bd: "#f5a4a4",
    fg: "#7f1d1d",
    hoverBg: "#ffc0c0",
    hoverBd: "#ef8585",
  },
};

/* -------------------------
    2. Button Core Style
------------------------- */
export const ActionGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

/* -------------------------
   3. Button Design (NEW)
------------------------- */
export const Button = styled.button<{ $variant?: keyof typeof COLOR }>`
  ${({ $variant = "neutral" }) => {
    const c = COLOR[$variant];
    return css`
      --fg: ${c.fg};
      --bg: linear-gradient(180deg, ${c.bg}, ${c.bg2});
      --bd: ${c.bd};
      --hover-bg: ${c.hoverBg};
      --hover-bd: ${c.hoverBd};
    `;
  }}

  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--bd);
  background: var(--bg);
  color: var(--fg);

  font-size: 13px;
  font-weight: 500;

  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08),
    0 0 0 2px rgba(255, 255, 255, 0.3) inset;

  transition: all 0.18s ease;

  /* hover */
  &:hover:not(:disabled) {
    background: var(--hover-bg);
    border-color: var(--hover-bd);
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);
  }

  /* active */
  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.16) inset;
  }

  /* disabled */
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    transform: none;
  }

  /* icon alignment */
  i {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
